// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ItsG","question":"styles_question__3GGDM","description":"styles_description__Ix0WO"};